import Vue from 'vue';

const files = require.context('@/layouts/.', false, /\.vue$/);
files.keys().forEach((fileName: string) => {
    const name = fileName?.split('/')?.pop()?.split('.');
    if (name && name?.length > 0) {
        Vue.component(`layout-${name[0]}`, files(fileName).default);
    }
});

const pages = require.context('@/layouts/page/.', false, /\.vue$/);
pages.keys().forEach((fileName: string) => {
    const name = fileName?.split('/')?.pop()?.split('.');
    if (name && name?.length > 0) {
        Vue.component(`layout-page-${name[0]}`, pages(fileName).default);
    }
});
